import clsx from "clsx";

import Button from "@mui/material/Button";

export default function LargeButton(props) {
	return (
		<Button
			className={clsx({
				[props.className || ""]: true,
				"large-button btn-rounded-bottom btn-regular-text btn-small-height": true,
			})}
			fullWidth={props.fullWidth || true}
			disableElevation
			disabled={props.disabled}
			size={props.size || "small"}
			variant={props.variant || "contained"}
			startIcon={props.startIcon || ""}
			endIcon={props.endIcon || ""}
			sx={{ color: props.color, backgroundColor: props.bgColor }}
			onClick={props.onClick}
		>
			{props.text || ""}
		</Button>
	);
}
